import { render, staticRenderFns } from "./HelpCenterTypes.vue?vue&type=template&id=6233c8e0&"
import script from "./HelpCenterTypes.vue?vue&type=script&lang=js&"
export * from "./HelpCenterTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports